import React from "react";
import PropTypes from "prop-types";
import SectionItem from "./SectionItem.jsx";
import AudioFile from "./AudioFile.jsx";
import EmailDelivery from "./EmailDelivery.jsx";
import { OnlinePlayback } from "./OnlinePlayback.jsx";
import { ServerDelivery } from "./ServerDelivery.jsx";

export const Voicemail = (props) => (
  <span>
    <SectionItem itemKey="Audio">
      <AudioFile audioId={props.config.audio} />
    </SectionItem>
    <EmailDelivery emailGroup={props.config.emailGroup} />
    <OnlinePlayback
      enabled={props.config.showOnline}
      storageDays={props.config.storageDays}
    />
    <ServerDelivery server={props.config.remoteServer} />
  </span>
);

export default Voicemail;

Voicemail.propTypes = {
  config: PropTypes.object,
};
